
const { Application } = Shopware;

Application.addServiceProviderDecorator('privileges', (privileges) => {
    privileges.addPrivilegeMappingEntry({
        category: 'permissions',
        parent:   'marketing',
        key:      'sellops_upsell',
        roles: {
            viewer: {
                privileges: [
                    'sellops_upsell_rule:read',
                    'sellops_upsell_analytics:read',
                    'payment_method:read',
                ],
                dependencies: [],
            },
            editor: {
                privileges: [
                    'sellops_upsell_rule:create',
                    'sellops_upsell_rule:update',
                    'sellops_upsell_rule:delete',
                ],
                dependencies: [
                    'sellops_upsell.viewer',
                ],
            },
        },
    });

    return privileges;
});
